import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Stack,
  Card,
  SimpleGrid,
  Badge,
  Center,
  Image,
  Pagination,
  Loader,
  Box
} from '@mantine/core';
import {
  IconBuildingStore,
  IconArrowLeft,
  IconCalendar,
  IconUser
} from '@tabler/icons-react';

const BlogPost = ({ post }) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Stack gap="md">
        <Image
          src={post.image}
          alt={post.title}
          height={200}
          fit="cover"
          radius="md"
        />
        <Title order={3}>{post.title}</Title>
        <Group gap="md">
          <Group gap="xs">
            <IconUser size="1rem" />
            <Text size="sm" c="dimmed">{post.author}</Text>
          </Group>
          <Group gap="xs">
            <IconCalendar size="1rem" />
            <Text size="sm" c="dimmed">{post.date}</Text>
          </Group>
        </Group>
        <Text size="sm" lineClamp={3}>
          {post.excerpt}
        </Text>
        <Button
          component={Link}
          to={`/blog/${post.id}`}
          variant="light"
          fullWidth
        >
          Read More
        </Button>
      </Stack>
    </Card>
  );
};

const BlogPage = () => {
  // Sample blog posts - in production these would come from an API
  const [posts, setPosts] = useState([
    {
      id: 1,
      title: "Welcome to PediPiggy - Your Trusted Marketplace",
      author: "PediPiggy Team",
      date: "March 30, 2026",
      excerpt: "We're excited to announce the launch of PediPiggy, the premier marketplace for quality products from verified princesses. Join us on this magical journey!",
      image: "/pp-logo.png",
      content: "We're excited to announce the launch of PediPiggy, the premier marketplace for quality products from verified princesses. Our platform connects buyers with trusted sellers in a safe and magical environment. Whether you're looking for unique handcrafted items or specialty products, PediPiggy has you covered."
    },
    {
      id: 2,
      title: "How to Become a Verified Princess",
      author: "PediPiggy Team",
      date: "March 28, 2026",
      excerpt: "Learn about our verification process and how you can become a trusted seller on PediPiggy. Our team ensures quality and authenticity for every seller.",
      image: "/pp-logo.png",
      content: "Becoming a verified princess on PediPiggy is easy! Simply register as a seller, submit your identification documents, and our team will verify your identity within 24-48 hours. Once verified, you can start listing products and building your business."
    },
    {
      id: 3,
      title: "Tips for Finding the Best Products",
      author: "PediPiggy Team",
      date: "March 25, 2026",
      excerpt: "Discover how to navigate our marketplace and find the best products from verified princesses. Learn about our rating system and seller reviews.",
      image: "/pp-logo.png",
      content: "When shopping on PediPiggy, look for sellers with high ratings and verified badges. Read product reviews and check seller profiles to ensure you're getting quality products. Our secure payment system protects both buyers and sellers."
    }
  ]);

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <Center>
          <Stack gap="md" align="center" maw={600}>
            <Title order={1} ta="center">
              PediPiggy Blog
            </Title>
            <Text size="xl" ta="center" c="dimmed">
              News, updates, and tips from the PediPiggy team
            </Text>
          </Stack>
        </Center>

        <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing="lg">
          {posts.map((post) => (
            <BlogPost key={post.id} post={post} />
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
};

export default BlogPage;
